<div class="divbox" fxLayoutAlign="center center">
  <mat-card class="box">
    <div>

      <div class="divtitle">
        <mat-card-title class="clstitle">{{titleWorker}}</mat-card-title>
      </div>

      <div>
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()">
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'worker.name' | transloco}}</mat-label>
              <input matInput type="text" name="first_name" placeholder="{{'worker.name' | transloco}}"
                [(ngModel)]="first_name_Input" required maxlength="64">
              <mat-error>
                {{'worker.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'worker.surname' | transloco}}</mat-label>
              <input matInput type="text" name="last_name" placeholder="{{'worker.surname' | transloco}}" [(ngModel)]="last_name_Input" required maxlength="64">
              <mat-error>
                {{'worker.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            
            <mat-form-field class="full-width">
              <mat-label>{{'worker.dni' | transloco}}</mat-label>
              <input matInput type="text" name="dni" placeholder="{{'worker.dni' | transloco}}" [(ngModel)]="dni_Input" required maxlength="64">
              <mat-error>
                {{'worker.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>


            <mat-form-field class="full-width" *ngIf="storageService.roleId==1">
              <mat-label>{{'worker.company' | transloco}}</mat-label>
              <mat-select [(value)]="company_Selected" [formControl]="companyControl" required>
                @for (item of lstCompanies; track item) {
                  <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'worker.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>
          
            <br>

          </mat-card-content>

          <div style="margin-top: 20px;">
            <div class="button-row" fxLayoutAlign="end">
              <button mat-raised-button color="primary" type="button" (click)="onAlarmConfigItm()">{{'worker.configAlarm' | transloco}}</button>
              <button mat-raised-button color="primary" type="submit">{{'worker.save' | transloco}}</button>
              <button mat-raised-button color="warn" *ngIf="!new" type="button" (click)="onEliminarItm()">{{'worker.delete' | transloco}}</button>
              <button mat-raised-button color="basic" routerLink="/workers">{{'worker.cancel' | transloco}}</button>
            </div>
          </div>
        </form>
      </div>

  </div>
  </mat-card>
</div>

